import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  userInfo: null,
};

const userSlice = createSlice({
  name: 'LOGIN',
  initialState,
  reducers: {
  setUserData(state, action) {
      
      state.isLoggedIn = true;
      state.userInfo = action.payload;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.userInfo = null;
    },
  },
});

export const { setUserData, logout } = userSlice.actions;
export default userSlice.reducer;
